// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/lib/js/src/Css.js");
var Week = require("./week");
var $$Array = require("bs-platform/lib/js/array.js");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Login = require("./login");
var Reset = require("./reset");
var Theme = require("./theme");
var React = require("react");
var Js_exn = require("bs-platform/lib/js/js_exn.js");
var Wizard = require("./wizard");
var FoodDay = require("./foodDay");
var Network = require("./network");
var Storage = require("./storage");
var Testing = require("./testing");
var Workout = require("./workout");
var FoodWeek = require("./foodWeek");
var Js_types = require("bs-platform/lib/js/js_types.js");
var Register = require("./register");
var Settings = require("./settings");
var Dashboard = require("./dashboard");
var Knowledge = require("./knowledge");
var ResetExec = require("./resetExec");
var Caml_array = require("bs-platform/lib/js/caml_array.js");
var Caml_format = require("bs-platform/lib/js/caml_format.js");
var LogoutModal = require("./logoutModal");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var WorkoutView = require("./workoutView");
var WorkoutWeek = require("./workoutWeek");
var FoodDayStage = require("./foodDayStage");
var SupportFuncs = require("./supportFuncs");
var WorkoutConfig = require("./workoutConfig");
var KnowledgeEntry = require("./knowledgeEntry");
var WorkoutWeekBonus = require("./workoutWeekBonus");
var WorkoutWeekCardio = require("./workoutWeekCardio");
var Caml_builtin_exceptions = require("bs-platform/lib/js/caml_builtin_exceptions.js");
var Logout_iconSvg = require("./assets/logout_icon.svg");
var Mbb_logo_384Png = require("./assets/mbb_logo_384.png");
var Dashboard_iconSvg = require("./assets/dashboard_icon.svg");
var Logout_icon_hoverSvg = require("./assets/logout_icon_hover.svg");
var Dashboard_icon_hoverSvg = require("./assets/dashboard_icon_hover.svg");

((require('./app.css')));

var app = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.textAlign(Css.center),
          /* :: */[
            Css.width(/* `percent */[
                  -119887163,
                  100.0
                ]),
            /* :: */[
              Css.background(Css.hex("FCEBEC")),
              /* :: */[
                Css.overflowY(/* auto */-1065951377),
                /* :: */[
                  Css.minHeight(/* `vh */[
                        26418,
                        100.0
                      ]),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var appHeader = Css.style(/* :: */[
      Css.backgroundColor(/* `hex */[
            5194459,
            "FFBFC2"
          ]),
      /* :: */[
        Css.height(Css.px(65)),
        /* :: */[
          Css.alignSelf(Css.stretch),
          /* :: */[
            Css.flexDirection(Css.row),
            /* :: */[
              Css.justifyContent(Css.center),
              /* :: */[
                Css.alignItems(Css.center),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var appHeaderContent = Css.style(/* :: */[
      Css.maxWidth(Css.px(500)),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.justifyContent(Css.spaceBetween),
            /* [] */0
          ]
        ]
      ]
    ]);

var appHeaderContentSlim = Css.style(/* :: */[
      Css.maxWidth(Css.px(500)),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.justifyContent(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var appHeaderLinkLeft = Css.style(/* :: */[
      Css.color(Css.white),
      /* :: */[
        Css.selector("&:active", /* :: */[
              Css.color(/* `hex */[
                    5194459,
                    "00C9C8"
                  ]),
              /* [] */0
            ]),
        /* :: */[
          Css.media("(hover)", /* :: */[
                Css.selector("&:hover", /* :: */[
                      Css.color(/* `hex */[
                            5194459,
                            "00C9C8"
                          ]),
                      /* [] */0
                    ]),
                /* [] */0
              ]),
          /* :: */[
            Css.flexDirection(Css.column),
            /* :: */[
              Css.fontSize(Css.px(16)),
              /* :: */[
                Css.fontWeight(700),
                /* :: */[
                  Css.lineHeight(1.3),
                  /* :: */[
                    Css.textDecoration(/* none */-922086728),
                    /* :: */[
                      Css.cursor(/* pointer */-786317123),
                      /* :: */[
                        Css.marginLeft(Css.px(8)),
                        /* :: */[
                          Css.marginRight(Css.px(0)),
                          /* :: */[
                            Css.minWidth(Css.px(105)),
                            /* [] */0
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var appHeaderLinkRight = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.fontSize(Css.px(16)),
        /* :: */[
          Css.fontWeight(700),
          /* :: */[
            Css.lineHeight(1.3),
            /* :: */[
              Css.textDecoration(/* none */-922086728),
              /* :: */[
                Css.cursor(/* pointer */-786317123),
                /* :: */[
                  Css.color(Css.white),
                  /* :: */[
                    Css.marginLeft(Css.px(0)),
                    /* :: */[
                      Css.marginRight(Css.px(8)),
                      /* :: */[
                        Css.minWidth(Css.px(105)),
                        /* :: */[
                          Css.textAlign(/* right */-379319332),
                          /* [] */0
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var modal = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.fontSize(Css.px(16)),
        /* :: */[
          Css.fontWeight(700),
          /* :: */[
            Css.lineHeight(1.3),
            /* :: */[
              Css.textDecoration(/* none */-922086728),
              /* :: */[
                Css.cursor(/* pointer */-786317123),
                /* :: */[
                  Css.color(Css.white),
                  /* :: */[
                    Css.marginLeft(Css.px(0)),
                    /* :: */[
                      Css.marginRight(Css.px(8)),
                      /* :: */[
                        Css.minWidth(Css.px(105)),
                        /* :: */[
                          Css.textAlign(/* right */-379319332),
                          /* [] */0
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var iconStyle = Css.style(/* :: */[
      Css.fontSize(Css.px(20)),
      /* :: */[
        Css.transform(/* `scale */[
              -120664438,
              /* tuple */[
                1.2,
                1.2
              ]
            ]),
        /* :: */[
          Css.height(Css.px(20)),
          /* :: */[
            Css.marginTop(Css.px(5)),
            /* [] */0
          ]
        ]
      ]
    ]);

var headerTextEl = Css.style(/* :: */[
      Css.justifyContent(/* center */98248149),
      /* :: */[
        Css.textTransform(/* uppercase */-415330030),
        /* :: */[
          Css.fontSize(Css.px(12)),
          /* [] */0
        ]
      ]
    ]);

var Styles = /* module */[
  /* app */app,
  /* appHeader */appHeader,
  /* appHeaderContent */appHeaderContent,
  /* appHeaderContentSlim */appHeaderContentSlim,
  /* appHeaderLinkLeft */appHeaderLinkLeft,
  /* appHeaderLinkRight */appHeaderLinkRight,
  /* modal */modal,
  /* iconStyle */iconStyle,
  /* headerTextEl */headerTextEl
];

function setInitialRoute() {
  var url = ReasonReact.Router[/* dangerouslyGetInitialUrl */3](/* () */0);
  var match = url[/* path */0];
  if (match) {
    switch (match[0]) {
      case "dashboard" : 
      case "login" : 
          return /* Knowledge */5;
      default:
        return /* Knowledge */5;
    }
  } else {
    return /* Knowledge */5;
  }
}

function convToInt(theString) {
  try {
    return Caml_format.caml_int_of_string(theString);
  }
  catch (raw_exn){
    var exn = Js_exn.internalToOCamlException(raw_exn);
    if (exn[0] === Caml_builtin_exceptions.failure) {
      return 0;
    } else {
      throw exn;
    }
  }
}

var component = ReasonReact.reducerComponent("App");

function make() {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function (self) {
      var x = self[/* state */2][/* lastRoute */2];
      var match = +(self[/* state */2][/* lastRoute */2].length === 5) && self[/* state */2][/* loggedIn */1];
      if (match !== 0) {
        ReasonReact.Router[/* push */0]("/week/" + (Caml_array.caml_array_get(x, 0) + ("/workout/" + (Caml_array.caml_array_get(x, 1) + ("/" + (Caml_array.caml_array_get(x, 2) + ("/" + (Caml_array.caml_array_get(x, 3) + ("/" + Caml_array.caml_array_get(x, 4))))))))));
      } else {
        var match$1 = typeof (history) === "undefined" ? undefined : (history);
        var match$2 = typeof (window) === "undefined" ? undefined : (window);
        if (match$1 !== undefined) {
          if (match$2 !== undefined) {
            var match$3 = Js_types.classify(Event);
            if (typeof match$3 === "number") {
              if (match$3 === 3) {
                var ev = document.createEvent("Event");
                ev.initEvent("submit", true, true);
                console.log("IE fallback running");
              } else {
                match$2.dispatchEvent(new Event("popstate"));
              }
            } else if (match$3.tag === 3) {
              var ev$1 = document.createEvent("Event");
              ev$1.initEvent("submit", true, true);
              console.log("IE fallback2 running");
            } else {
              match$2.dispatchEvent(new Event("popstate"));
            }
          } else {
            console.log("no window");
          }
        } else {
          console.log("no history");
        }
      }
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function (self) {
      var route = self[/* state */2][/* route */0];
      var handleClickDash = function () {
        Storage.clearLoc(/* () */0);
        return ReasonReact.Router[/* push */0]("/dashboard");
      };
      var handleClickLogout = function () {
        return Curry._1(self[/* send */4], /* ShowLogout */5);
      };
      var changeDashHover = function () {
        return Curry._1(self[/* send */4], /* DashHover */0);
      };
      var changeDashNonHover = function () {
        return Curry._1(self[/* send */4], /* DashNonHover */2);
      };
      var changeLogoutHover = function () {
        return Curry._1(self[/* send */4], /* LogoutHover */3);
      };
      var changeLogoutNonHover = function () {
        return Curry._1(self[/* send */4], /* LogoutNonHover */4);
      };
      var match = self[/* state */2][/* loggedIn */1];
      var match$1 = self[/* state */2][/* logoutVisible */5];
      var tmp;
      if (typeof route === "number") {
        switch (route) {
          case 0 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, Login.make(/* array */[]));
              break;
          case 1 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, Register.make(/* array */[]));
              break;
          case 2 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, Reset.make(/* array */[]));
              break;
          case 3 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, Dashboard.make(/* array */[]));
              break;
          case 4 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, Settings.make(/* array */[]));
              break;
          case 5 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, Knowledge.make(/* array */[]));
              break;
          case 6 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, Testing.make(/* array */[]));
              break;
          case 7 : 
              tmp = React.createElement("p", undefined, "no route yet");
              break;
          
        }
      } else {
        switch (route.tag | 0) {
          case 0 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, ResetExec.make(route[0], /* array */[]));
              break;
          case 1 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, Wizard.make(route[0], /* array */[]));
              break;
          case 2 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, Week.make(route[0], /* array */[]));
              break;
          case 3 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, WorkoutWeek.make(route[0], /* array */[]));
              break;
          case 4 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, WorkoutWeekCardio.make(route[0], /* array */[]));
              break;
          case 5 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, WorkoutWeekBonus.make(route[0], /* array */[]));
              break;
          case 6 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, WorkoutConfig.make(route[0], route[1], /* array */[]));
              break;
          case 7 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, WorkoutView.make(route[0], route[1], /* array */[]));
              break;
          case 8 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, Workout.make(route[0], route[1], route[2], route[3], route[4], /* array */[]));
              break;
          case 9 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, FoodWeek.make(route[0], /* array */[]));
              break;
          case 10 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, FoodDay.make(route[0], /* array */[]));
              break;
          case 11 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, FoodDayStage.make(route[0], route[1], /* array */[]));
              break;
          case 12 : 
              tmp = ReasonReact.element(/* None */0, /* None */0, KnowledgeEntry.make(route[0], /* array */[]));
              break;
          
        }
      }
      return React.createElement("div", {
                  className: app
                }, React.createElement("div", {
                      className: appHeader
                    }, match !== 0 ? React.createElement("div", {
                            className: appHeaderContent
                          }, React.createElement("a", {
                                className: appHeaderLinkLeft,
                                onClick: handleClickDash,
                                onMouseOut: changeDashNonHover,
                                onMouseOver: changeDashHover
                              }, React.createElement("img", {
                                    className: iconStyle,
                                    alt: "",
                                    src: self[/* state */2][/* srcDash */3]
                                  }), React.createElement("div", {
                                    className: headerTextEl
                                  }, "Dashboard")), React.createElement("img", {
                                className: "App-logo",
                                alt: "logo",
                                src: Mbb_logo_384Png
                              }), React.createElement("a", {
                                className: appHeaderLinkLeft,
                                onClick: handleClickLogout,
                                onMouseOut: changeLogoutNonHover,
                                onMouseOver: changeLogoutHover
                              }, React.createElement("img", {
                                    className: iconStyle,
                                    alt: "",
                                    src: self[/* state */2][/* srcLogout */4]
                                  }), React.createElement("div", {
                                    className: headerTextEl
                                  }, "Logout"))) : React.createElement("div", {
                            className: appHeaderContentSlim
                          }, React.createElement("img", {
                                className: "App-logo",
                                alt: "logo",
                                src: Mbb_logo_384Png
                              }))), match$1 !== 0 ? ReasonReact.element(/* None */0, /* None */0, LogoutModal.make((function () {
                              return Curry._1(self[/* send */4], /* HideLogout */6);
                            }), (function () {
                              return Curry._1(self[/* send */4], /* HideLogoutAndLogout */7);
                            }), /* array */[])) : null, React.createElement("main", {
                      className: Theme.main
                    }, React.createElement("div", {
                          className: Theme.contentBox
                        }, tmp)));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* route */setInitialRoute(/* () */0),
              /* loggedIn */Storage.checkIfLoggedIn(/* () */0),
              /* lastRoute */Storage.checkForLastRouteFromLs(/* () */0),
              /* srcDash */Dashboard_iconSvg,
              /* srcLogout */Logout_iconSvg,
              /* logoutVisible : false */0
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        switch (action) {
          case 0 : 
              var newrecord = state.slice();
              return /* Update */Block.__(0, [(newrecord[/* srcDash */3] = Dashboard_icon_hoverSvg, newrecord)]);
          case 1 : 
              return /* Update */Block.__(0, [/* record */[
                          /* route */state[/* route */0],
                          /* loggedIn */state[/* loggedIn */1],
                          /* lastRoute */state[/* lastRoute */2],
                          /* srcDash */Dashboard_iconSvg,
                          /* srcLogout */Logout_iconSvg,
                          /* logoutVisible */state[/* logoutVisible */5]
                        ]]);
          case 2 : 
              var newrecord$1 = state.slice();
              return /* Update */Block.__(0, [(newrecord$1[/* srcDash */3] = Dashboard_iconSvg, newrecord$1)]);
          case 3 : 
              var newrecord$2 = state.slice();
              return /* Update */Block.__(0, [(newrecord$2[/* srcLogout */4] = Logout_icon_hoverSvg, newrecord$2)]);
          case 4 : 
              var newrecord$3 = state.slice();
              return /* Update */Block.__(0, [(newrecord$3[/* srcLogout */4] = Logout_iconSvg, newrecord$3)]);
          case 5 : 
              var newrecord$4 = state.slice();
              return /* Update */Block.__(0, [(newrecord$4[/* logoutVisible */5] = /* true */1, newrecord$4)]);
          case 6 : 
              var newrecord$5 = state.slice();
              return /* Update */Block.__(0, [(newrecord$5[/* logoutVisible */5] = /* false */0, newrecord$5)]);
          case 7 : 
              var newrecord$6 = state.slice();
              return /* UpdateWithSideEffects */Block.__(3, [
                        (newrecord$6[/* logoutVisible */5] = /* false */0, newrecord$6),
                        (function () {
                            return SupportFuncs.handleLogout(/* () */0);
                          })
                      ]);
          case 8 : 
              return /* SideEffects */Block.__(2, [(function () {
                            var syncStatus = Network.pullSyncConfig(/* () */0);
                            var syncIt = function () {
                              console.log("syncIt");
                              Network.initializeSyncStatus2(/* () */0);
                              return Network.pullData("", (function (data) {
                                            return Network.successSyncAllNoRedirect(data, (function () {
                                                          return /* () */0;
                                                        }));
                                          }));
                            };
                            var x = $$Array.to_list(syncStatus);
                            var exists = function (p, _param) {
                              while(true) {
                                var param = _param;
                                if (param) {
                                  if (Curry._1(p, param[0])) {
                                    return /* true */1;
                                  } else {
                                    _param = param[1];
                                    continue ;
                                    
                                  }
                                } else {
                                  return /* false */0;
                                }
                              };
                            };
                            var dirty = exists((function (item) {
                                    return +(Caml_array.caml_array_get(item, 0) === "fresh");
                                  }), x);
                            if (dirty) {
                              console.log("dirty");
                              syncIt(/* () */0);
                            }
                            return /* () */0;
                          })]);
          
        }
      } else if (action.tag) {
        var url = action[1];
        return /* UpdateWithSideEffects */Block.__(3, [
                  /* record */[
                    /* route */action[0],
                    /* loggedIn */Storage.checkIfLoggedIn(/* () */0),
                    /* lastRoute */state[/* lastRoute */2],
                    /* srcDash */state[/* srcDash */3],
                    /* srcLogout */state[/* srcLogout */4],
                    /* logoutVisible */state[/* logoutVisible */5]
                  ],
                  (function (self) {
                      if (url !== "nothing") {
                        console.log("pushing redirect: ", url);
                        return ReasonReact.Router[/* push */0]("/" + url);
                      } else {
                        console.log("pushing login ");
                        return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* Login */0]));
                      }
                    })
                ]);
      } else {
        return /* UpdateWithSideEffects */Block.__(3, [
                  /* record */[
                    /* route */action[0],
                    /* loggedIn */Storage.checkIfLoggedIn(/* () */0),
                    /* lastRoute */state[/* lastRoute */2],
                    /* srcDash */Dashboard_iconSvg,
                    /* srcLogout */state[/* srcLogout */4],
                    /* logoutVisible */state[/* logoutVisible */5]
                  ],
                  (function () {
                      window.scrollTo(0, 0);
                      return /* () */0;
                    })
                ]);
      }
    });
  newrecord[/* subscriptions */13] = (function (self) {
      return /* :: */[
              /* Sub */[
                (function () {
                    return ReasonReact.Router[/* watchUrl */1]((function (url) {
                                  var match = url[/* path */0];
                                  var match$1 = Storage.checkIfLoggedIn(/* () */0);
                                  var exit = 0;
                                  if (match) {
                                    switch (match[0]) {
                                      case "" : 
                                          if (match[1]) {
                                            exit = 1;
                                          } else if (match$1 !== 0) {
                                            return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                          /* Dashboard */3,
                                                          "dashboard"
                                                        ]));
                                          } else {
                                            return ReasonReact.Router[/* push */0]("/login");
                                          }
                                          break;
                                      case "dashboard" : 
                                          if (match[1]) {
                                            exit = 1;
                                          } else if (match$1 !== 0) {
                                            return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* Dashboard */3]));
                                          } else {
                                            return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                          /* Login */0,
                                                          "login"
                                                        ]));
                                          }
                                          break;
                                      case "fallback" : 
                                          if (match[1]) {
                                            exit = 1;
                                          } else {
                                            return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* Knowledge */5]));
                                          }
                                          break;
                                      case "foodday" : 
                                          var match$2 = match[1];
                                          if (match$2) {
                                            var match$3 = match$2[1];
                                            var day = match$2[0];
                                            if (match$3) {
                                              if (match$3[1]) {
                                                exit = 1;
                                              } else if (match$1 !== 0) {
                                                var stage = match$3[0];
                                                if (convToInt(day) > 0 && convToInt(day) < 29 && (stage === "breakfast" || stage === "snack" || stage === "lunch" || stage === "dinner")) {
                                                  return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* FoodDayStage */Block.__(11, [
                                                                    day,
                                                                    stage
                                                                  ])]));
                                                } else {
                                                  exit = 1;
                                                }
                                              } else {
                                                return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                              /* Login */0,
                                                              "login"
                                                            ]));
                                              }
                                            } else if (match$1 !== 0) {
                                              if (convToInt(day) === 0) {
                                                return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* FoodDay */Block.__(10, ["1"])]));
                                              } else if (convToInt(day) > 0 && convToInt(day) < 29) {
                                                return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* FoodDay */Block.__(10, [day])]));
                                              } else {
                                                exit = 1;
                                              }
                                            } else {
                                              return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                            /* Login */0,
                                                            "login"
                                                          ]));
                                            }
                                          } else {
                                            exit = 1;
                                          }
                                          break;
                                      case "knowledge" : 
                                          var match$4 = match[1];
                                          if (match$4) {
                                            if (match$4[1]) {
                                              exit = 1;
                                            } else if (match$1 !== 0) {
                                              var entry = match$4[0];
                                              if (convToInt(entry) > 0 && convToInt(entry) < 25) {
                                                return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* KnowledgeEntry */Block.__(12, [entry])]));
                                              } else {
                                                exit = 1;
                                              }
                                            } else {
                                              return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                            /* Login */0,
                                                            "login"
                                                          ]));
                                            }
                                          } else if (match$1 !== 0) {
                                            return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* Knowledge */5]));
                                          } else {
                                            return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                          /* Login */0,
                                                          "login"
                                                        ]));
                                          }
                                          break;
                                      case "login" : 
                                          if (match[1]) {
                                            exit = 1;
                                          } else if (match$1 !== 0) {
                                            return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                          /* Dashboard */3,
                                                          "dashboard"
                                                        ]));
                                          } else {
                                            return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* Login */0]));
                                          }
                                          break;
                                      case "password-reset" : 
                                          var match$5 = match[1];
                                          if (match$5) {
                                            if (match$5[1]) {
                                              exit = 1;
                                            } else {
                                              return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* ResetExec */Block.__(0, [match$5[0]])]));
                                            }
                                          } else {
                                            return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* ResetExec */Block.__(0, [""])]));
                                          }
                                          break;
                                      case "register" : 
                                          if (match[1]) {
                                            exit = 1;
                                          } else if (match$1 !== 0) {
                                            return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                          /* Dashboard */3,
                                                          "dashboard"
                                                        ]));
                                          } else {
                                            return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* Register */1]));
                                          }
                                          break;
                                      case "reset" : 
                                          if (match[1]) {
                                            exit = 1;
                                          } else {
                                            return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* Reset */2]));
                                          }
                                          break;
                                      case "settings" : 
                                          if (match[1]) {
                                            exit = 1;
                                          } else if (match$1 !== 0) {
                                            return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* Settings */4]));
                                          } else {
                                            return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                          /* Login */0,
                                                          "login"
                                                        ]));
                                          }
                                          break;
                                      case "testing" : 
                                          if (match[1]) {
                                            exit = 1;
                                          } else if (match$1 !== 0) {
                                            return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* Testing */6]));
                                          } else {
                                            return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                          /* Login */0,
                                                          "login"
                                                        ]));
                                          }
                                          break;
                                      case "week" : 
                                          var match$6 = match[1];
                                          if (match$6) {
                                            var match$7 = match$6[1];
                                            var week = match$6[0];
                                            if (match$7) {
                                              switch (match$7[0]) {
                                                case "bonus" : 
                                                    if (match$7[1]) {
                                                      exit = 1;
                                                    } else if (match$1 !== 0) {
                                                      if (week === "1" || week === "2" || week === "3" || week === "4") {
                                                        return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* WorkoutWeekBonus */Block.__(5, [week])]));
                                                      } else {
                                                        exit = 1;
                                                      }
                                                    } else {
                                                      return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                                    /* Login */0,
                                                                    "login"
                                                                  ]));
                                                    }
                                                    break;
                                                case "cardio" : 
                                                    if (match$7[1]) {
                                                      exit = 1;
                                                    } else if (match$1 !== 0) {
                                                      if (week === "1" || week === "2" || week === "3" || week === "4") {
                                                        return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* WorkoutWeekCardio */Block.__(4, [week])]));
                                                      } else {
                                                        exit = 1;
                                                      }
                                                    } else {
                                                      return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                                    /* Login */0,
                                                                    "login"
                                                                  ]));
                                                    }
                                                    break;
                                                case "foodweek" : 
                                                    if (match$7[1]) {
                                                      exit = 1;
                                                    } else if (match$1 !== 0) {
                                                      if (week === "1" || week === "2" || week === "3" || week === "4") {
                                                        return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* FoodWeek */Block.__(9, [week])]));
                                                      } else {
                                                        exit = 1;
                                                      }
                                                    } else {
                                                      return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                                    /* Login */0,
                                                                    "login"
                                                                  ]));
                                                    }
                                                    break;
                                                case "workout" : 
                                                    var match$8 = match$7[1];
                                                    if (match$8) {
                                                      var match$9 = match$8[1];
                                                      if (match$9) {
                                                        var round = match$9[0];
                                                        var workout = match$8[0];
                                                        var exit$1 = 0;
                                                        switch (round) {
                                                          case "config" : 
                                                              if (match$9[1]) {
                                                                exit$1 = 2;
                                                              } else if (match$1 !== 0) {
                                                                if (convToInt(workout) > 0 && convToInt(workout) < 5 && week === "1" || week === "2" || week === "3" || week === "4") {
                                                                  return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* WorkoutConfig */Block.__(6, [
                                                                                    week,
                                                                                    workout
                                                                                  ])]));
                                                                } else {
                                                                  exit = 1;
                                                                }
                                                              } else {
                                                                return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                                              /* Login */0,
                                                                              "login"
                                                                            ]));
                                                              }
                                                              break;
                                                          case "view" : 
                                                              if (match$9[1]) {
                                                                exit$1 = 2;
                                                              } else if (match$1 !== 0) {
                                                                if (convToInt(workout) > 0 && convToInt(workout) < 5 && week === "1" || week === "2" || week === "3" || week === "4") {
                                                                  return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* WorkoutView */Block.__(7, [
                                                                                    week,
                                                                                    workout
                                                                                  ])]));
                                                                } else {
                                                                  exit = 1;
                                                                }
                                                              } else {
                                                                return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                                              /* Login */0,
                                                                              "login"
                                                                            ]));
                                                              }
                                                              break;
                                                          default:
                                                            exit$1 = 2;
                                                        }
                                                        if (exit$1 === 2) {
                                                          var match$10 = match$9[1];
                                                          if (match$10) {
                                                            var match$11 = match$10[1];
                                                            if (match$11 && !match$11[1]) {
                                                              if (match$1 !== 0) {
                                                                var step = match$11[0];
                                                                var pair = match$10[0];
                                                                if (convToInt(workout) > 0 && convToInt(workout) < 5 && (week === "1" || week === "2" || week === "3" || week === "4") && (round === "1" || round === "2" || round === "3" || round === "4") && (pair === "1" || pair === "2" || pair === "3") && (step === "2" || step === "3" || step === "4" || step === "5" || step === "6" || step === "7")) {
                                                                  var match$12 = +(step !== "5" && step !== "6" && step !== "7");
                                                                  if (match$12 !== 0) {
                                                                    Storage.storeLoc(week, workout, round, pair, step);
                                                                  }
                                                                  return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* Workout */Block.__(8, [
                                                                                    week,
                                                                                    workout,
                                                                                    round,
                                                                                    pair,
                                                                                    step
                                                                                  ])]));
                                                                } else {
                                                                  exit = 1;
                                                                }
                                                              } else {
                                                                return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                                              /* Login */0,
                                                                              "login"
                                                                            ]));
                                                              }
                                                            } else {
                                                              exit = 1;
                                                            }
                                                          } else {
                                                            exit = 1;
                                                          }
                                                        }
                                                        
                                                      } else {
                                                        exit = 1;
                                                      }
                                                    } else {
                                                      exit = 1;
                                                    }
                                                    break;
                                                case "workoutweek" : 
                                                    if (match$7[1]) {
                                                      exit = 1;
                                                    } else if (match$1 !== 0) {
                                                      if (week === "1" || week === "2" || week === "3" || week === "4") {
                                                        return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* WorkoutWeek */Block.__(3, [week])]));
                                                      } else {
                                                        exit = 1;
                                                      }
                                                    } else {
                                                      return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                                    /* Login */0,
                                                                    "login"
                                                                  ]));
                                                    }
                                                    break;
                                                default:
                                                  exit = 1;
                                              }
                                            } else if (match$1 !== 0) {
                                              if (week === "1" || week === "2" || week === "3" || week === "4") {
                                                return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* Week */Block.__(2, [week])]));
                                              } else {
                                                exit = 1;
                                              }
                                            } else {
                                              return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                            /* Login */0,
                                                            "login"
                                                          ]));
                                            }
                                          } else {
                                            exit = 1;
                                          }
                                          break;
                                      case "wizard" : 
                                          var match$13 = match[1];
                                          if (match$13 && !match$13[1]) {
                                            if (match$1 !== 0) {
                                              return Curry._1(self[/* send */4], /* Navigate */Block.__(0, [/* Wizard */Block.__(1, [match$13[0]])]));
                                            } else {
                                              return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                            /* Login */0,
                                                            "login"
                                                          ]));
                                            }
                                          } else {
                                            exit = 1;
                                          }
                                          break;
                                      default:
                                        exit = 1;
                                    }
                                  } else {
                                    exit = 1;
                                  }
                                  if (exit === 1) {
                                    if (match$1 !== 0) {
                                      return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                    /* Dashboard */3,
                                                    "dashboard"
                                                  ]));
                                    } else {
                                      return Curry._1(self[/* send */4], /* Redirect */Block.__(1, [
                                                    /* Login */0,
                                                    "login"
                                                  ]));
                                    }
                                  }
                                  
                                }));
                  }),
                ReasonReact.Router[/* unwatchUrl */2]
              ],
              /* :: */[
                /* Sub */[
                  (function () {
                      return setInterval((function () {
                                    return Curry._1(self[/* send */4], /* CheckFresh */8);
                                  }), 15000);
                    }),
                  (function (prim) {
                      clearInterval(prim);
                      return /* () */0;
                    })
                ],
                /* [] */0
              ]
            ];
    });
  return newrecord;
}

exports.Styles = Styles;
exports.setInitialRoute = setInitialRoute;
exports.convToInt = convToInt;
exports.component = component;
exports.make = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/app.re
// module id = 71
// module chunks = 0